import { InjectionToken } from '@angular/core'

import { AuthStore } from '../auth/auth.store'

export const AUTH_STORE = new InjectionToken<AuthStore>('AUTH_STORE')
